import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref } from "vue"

const _hoisted_1 = {
  class: "table-container",
  style: {"width":"100%"}
}
const _hoisted_2 = { class: "table" }
const _hoisted_3 = { class: "align-center" }
const _hoisted_4 = { class: "align-center" }
const _hoisted_5 = { class: "align-center" }
const _hoisted_6 = { class: "align-center" }
const _hoisted_7 = { class: "align-center" }
const _hoisted_8 = { class: "align-center" }
const _hoisted_9 = { class: "align-right" }
const _hoisted_10 = { class: "align-center" }

import { PropType } from 'vue'

import { ScoredTeam } from '@/store/public/leagues.types'
import { formatFloat, formatValue } from '@/utils/format'


export default /*@__PURE__*/_defineComponent({
  __name: 'LeagueMatchTeamTable',
  props: {
  team: {
    type: Object as PropType<ScoredTeam>,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(__props.team?.name), 1),
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _cache[0] || (_cache[0] = _createElementVNode("th", { class: "fit-content" }, null, -1)),
          _createElementVNode("th", null, _toDisplayString(_ctx.$t('leagues.labels.bowler')), 1),
          _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.$t('bowler-scores.score')), 1),
          _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t('leagues.labels.bonus')), 1)
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.team?.bowlers, (row, i) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: `rundown-row-${i}`
          }, [
            _createElementVNode("td", null, _toDisplayString(i + 1) + ".", 1),
            _createElementVNode("td", null, _toDisplayString(_unref(formatValue)(row.full_name)), 1),
            _createElementVNode("td", _hoisted_5, _toDisplayString(_unref(formatFloat)(row.score, 0)), 1),
            _createElementVNode("td", _hoisted_6, _toDisplayString(_unref(formatFloat)(row.personal_bonus, 0)), 1)
          ]))
        }), 128)),
        _createElementVNode("tr", null, [
          _cache[1] || (_cache[1] = _createElementVNode("td", null, null, -1)),
          _cache[2] || (_cache[2] = _createElementVNode("td", null, null, -1)),
          _createElementVNode("td", _hoisted_7, _toDisplayString(_unref(formatFloat)(__props.team.team_score, 0)), 1),
          _createElementVNode("td", _hoisted_8, _toDisplayString(_unref(formatFloat)(__props.team.team_bonus, 0)), 1)
        ]),
        _createElementVNode("tr", null, [
          _cache[3] || (_cache[3] = _createElementVNode("td", null, null, -1)),
          _createElementVNode("td", _hoisted_9, [
            _createElementVNode("b", null, _toDisplayString(_ctx.$t('leagues.labels.points')), 1)
          ]),
          _createElementVNode("td", _hoisted_10, [
            _createElementVNode("b", null, _toDisplayString(_unref(formatFloat)(__props.team.team_points, 0)), 1)
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("td", null, null, -1))
        ])
      ])
    ])
  ]))
}
}

})